import {ErrorOutline} from '@mui/icons-material'
import Typography from '@mui/material/Typography'
import React from 'react'
import {StyledCenteredDiv} from '@/components/pages/NewDatasetJobPage/StyledCenteredDiv'

type NewJobApiErrorProps = {
    text: string
}

const NewJobApiError = ({text}: NewJobApiErrorProps) => {
    return <div>
        <StyledCenteredDiv>
            <ErrorOutline color="error" fontSize="large"/>
        </StyledCenteredDiv>
        <StyledCenteredDiv>
            <Typography>{text}</Typography>
        </StyledCenteredDiv>
    </div>
}

export default NewJobApiError